import { Fragment } from 'react'
/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/core'
import Heading from './Heading'
import { ReactComponent as OkIcon } from '../../assets/icons/ok-black.svg'

const showAnimation = keyframes`
 from {
  transform: scale(0.5) translateY(20px);
  opacity: 0.7;
 }
`

const containerCss = (theme) => css`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${theme.background || '#f8f8fa'};
  ${theme.color &&
  css`
    color: ${theme.color};
  `}

  .heading {
    width: 100%;
    height: 30px;
    max-width: 430px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 16px;
    background-color: ${theme.container_background || 'white'};
    box-shadow: ${theme.container_box_shadow ||
    'rgb(228 228 228) 0px 1px 5px 0px'};
    padding: 10px 20px;
    border-radius: 10px;

    > a {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }

  .surveys-logo {
    width: 30px;
    height: 100%;
  }
`

const sentCss = (theme) => css`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 450px;
  background-color: ${theme.container_background || 'white'};
  box-shadow: ${theme.container_box_shadow ||
  'rgb(228 228 228) 0px 1px 5px 0px'};

  @media (min-width: 400px) {
    height: calc(80% - 100px);
    padding: 0 10px;
    border-radius: 10px;
  }

  .thank-you {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 80px;
  }

  .text {
    text-align: center;
  }

  .main-text {
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 3px;
  }

  .icon {
    margin-bottom: 5px;
    width: 150px;
    height: 50px;
    animation: ${showAnimation} 0.3s ease;

    > path {
      fill: ${theme.thank_you?.icon_color || '#38C776'};
    }
  }
`

const Sent = ({ isWide, isLoading, survey, theme }) => {
  const { staticContent = {} } = survey

  return (
    <div css={containerCss(theme)}>
      {isWide && <Heading isLoading={isLoading} survey={survey} />}
      <div css={sentCss(theme)}>
        <div className="thank-you">
          <OkIcon className="icon" />
          <div className="text">
            <span className="main-text">
              {staticContent?.confirmation_title ||
                'Thank you for your feedback.'}
            </span>
            <br />
            {staticContent?.confirmation_description || (
              <Fragment>
                We appreciate you sharing <br /> your thoughts.
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sent
